import { render, staticRenderFns } from "./UpdatePasswordSlidebar.vue?vue&type=template&id=9eb01e08"
import script from "./UpdatePasswordSlidebar.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports